<template>
    <div class="free-payment">
        <PublicOfferAuth
            :order-id="order.id"
            class="mt-20"
            @auth="$emit('handleAuth', $event)"
            v-if="showAuth && !auth"
        />

        <DefaultButton
            v-else
            size="x-large"
            :text="t(showAuth ? 'expert.get_access' : 'payments.start')"
            :background="showAuth ? 'blue' : 'green'"
            class="full-width mt-20"
            @click="handleClick"
        />
    </div>
</template>

<script>
import DefaultButton from "@components/Buttons/DefaultButton.vue"
import PublicOfferAuth from "./PublicOfferAuth.vue"

export default {
    props: {
        order: {
            type: Object,
            default: () => {}
        },
        auth: {
            type: Boolean,
            default: false
        }
    },
    name: "PublicOfferFreePayment",
    components: { PublicOfferAuth, DefaultButton },
    data() {
        return {
            showAuth: false
        }
    },
    methods: {
        handleClick() {
            if (this.auth) {
                this.$emit("handlePaymentLinks")
            } else {
                this.showAuth = true
            }
        }
    }
}
</script>

<style scoped lang="sass">

</style>
